import template from './template.html';
import controller from './controller';

const startDate = new Date();
startDate.setMonth(startDate.getMonth() - 6);
startDate.setHours(0, 0, 0, 0);

const endDate = new Date();
endDate.setMonth(endDate.getMonth() + 12);
endDate.setHours(23, 59, 59, 999);

export default {
  url: '/event-manager?reload&startTime&endTime',
  stateName: 'Event Manager',
  data: {
    specialClass: 'fixed-sidebar'
  },
  params: {
    startTime: {
      type: 'int',
      value: startDate.getTime(),
      squash: false
    },
    endTime: {
      type: 'int',
      value: endDate.getTime(),
      squash: false
    }
  },
  reloadOnSearch: false,
  views: {
    'a@app': {
      template,
      controller,
      controllerAs: 'EventManagerCtrl'
    }
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    refresh: /* @ngInject */ ResolveClass => {
      return ResolveClass.refreshLogin();
    },
    authorAuth: /* @ngInject */ ResolveClass =>
      ResolveClass.refreshLogin().then(() => ResolveClass.authenticateEventCoordinator()),
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/admin/event-manager')
  }
};



// WEBPACK FOOTER //
// ./src/app/controllers/admin/events/index.js